import React, { useLayoutEffect } from 'react';
import { KeyboardAvoidingView, Platform, View } from 'react-native';
import { useNavigation, useRoute, useIsFocused } from '@react-navigation/native';
import { createGroupChannelFragment, GroupChannelModule, useSendbirdChat } from '@sendbird/uikit-react-native';
import { useGroupChannel } from '@sendbird/uikit-chat-hooks';
import { withSendbirdConnection, CustomChatHeader } from '../components';
import ChatGroupChannelInput from '../components/ChatGroupChannelInput';
import { Loading } from '@shared/components/loading';
import { requiresKeyboardAvoiding } from '@shared/utils/deviceUtils';
import { IGroupChannelContentProps } from '../types';
import { useTranslation } from 'react-i18next';

const UseReactNavigationHeader: GroupChannelModule['Header'] = ({ onPressHeaderRight, onPressHeaderLeft }) => {
    return null;
};

const GroupChannelFragment = createGroupChannelFragment({
    Header: UseReactNavigationHeader,
    Input: ChatGroupChannelInput
});

const GroupChannelContent: React.FC<IGroupChannelContentProps> = () => {
    const navigation = useNavigation<any>();
    const { params } = useRoute<any>();
    const { sdk } = useSendbirdChat();
    const { channel } = useGroupChannel(sdk, params.channelUrl);
    const { t } = useTranslation();
    const isFocused = useIsFocused();

    useLayoutEffect(() => {
        navigation.setOptions({
            headerShown: false,
        });
    }, [navigation]);

    if (!channel) {
        return <Loading message={t('commons.loading.generic')} />;
    }

    const channelFragment = (
        <View style={{ flex: 1 }}>
            <CustomChatHeader
                channel={channel}
                onPressLeft={() => navigation.goBack()}
                onPressRight={() => {
                }}
            />
            {isFocused && (
                <GroupChannelFragment
                    channel={channel}
                    onChannelDeleted={() => {
                        navigation.navigate('GroupChannelList');
                    }}
                    onPressHeaderLeft={() => {
                    }}
                    onPressHeaderRight={() => {
                    }}
                />
            )}
        </View>
    );

    return requiresKeyboardAvoiding() ? (
        <KeyboardAvoidingView
            style={{ flex: 1 }}
            behavior={Platform.OS === 'ios' ? 'padding' : 'height'}>
            {channelFragment}
        </KeyboardAvoidingView>
    ) : (
        channelFragment
    );
};

export const GroupChannelScreen = withSendbirdConnection(
    GroupChannelContent,
    {
        useDetailedConnectionStatus: false,
    }
);
